// extracted by mini-css-extract-plugin
module.exports = {"ButtonWrapper":"Content__ButtonWrapper_asrco","Title":"Content__Title_bqkJj"};